import { apiDev } from '@/scripts/axios';
import { catchError } from '@/scripts/utils/store-dependent';

const getGames = () =>
  apiDev
    .get(`games`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getGame = id =>
  apiDev
    .get(`games/${id}`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getGameInstructions = (id, platformID) =>
  apiDev
    .get(`games/${id}/connectionInstructions`, { params: { platformID } })
    .then(({ data: { response } }) => response)
    .catch(catchError);

const getGameTypes = id =>
  apiDev
    .get(`games/${id}/types`)
    .then(({ data: { response } }) => response)
    .catch(catchError);

export { getGames, getGame, getGameInstructions, getGameTypes };
